import React from 'react';
interface CTAButtonProps {
  text: string;
  className?: string;
}
export function CTAButton({
  text,
  className = ''
}: CTAButtonProps) {
  // Replace $29 with strikethrough $70 followed by $29
  const updatedText = text.replace(/\$29/g, '<span class="text-gray-500 line-through mr-1">$70</span>$29');
  return <a href="https://www.neurotoned.com/offers/sPjut2p7/checkout?coupon_code=21OFFNEUROPROGRAMNEWMEMBERS" className={`inline-block px-8 py-4 bg-gradient-to-r from-teal-500 to-blue-600 hover:from-teal-600 hover:to-blue-700 text-white font-medium rounded-lg shadow-md transition duration-300 text-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-50 text-center mx-auto ${className}`} dangerouslySetInnerHTML={{
    __html: updatedText
  }} data-id="element-299" />;
}